(function ($) {
  Drupal.behaviors.gtlRowMobileV1 = {
    attach: function (context, settings) {
      $('.gtl-row-mobile-v1').each(function () {
        var thisFormatter = $(this);
        var link = thisFormatter.find('.link a');
        var href = link.attr('href');

        thisFormatter.find('.image img').wrap('<a href="' + href + '" title="' + link.text() + '"></a>');
      });
    }
  };
})(jQuery);
